export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "Caixa de mensagens",
    subtitle: "WhatsApp, concierge web e OTA em um só lugar",
  },

  channels: {
    all: "Todos",
    whatsapp: "WhatsApp",
    web: "Web",
    ota: "OTA",
  },

  empty: {
    title: "Nenhuma mensagem nova",
    description: "As novas mensagens do bot aparecerão aqui quando chegarem",
  },

  buttons: {
    markAll: "Marcar todas como lidas",
    goToChat: "Configurar Agente de IA",
    archive: "Arquivar conversa",
  },

  actions: {
    replyWhatsApp: "Responder no WhatsApp",
  },

  time: {
    now: "Agora",
    minuteSuffix: "m",
    hourSuffix: "h",
    daySuffix: "d",
    today: "Hoje",
    yesterday: "Ontem",
  },

  questions: {
    searchPlaceholder: "Buscar perguntas...",
    answered: "Respondida",
    noAnswer: "Pendente",
    withImage: "Com imagem",
    empty: "Nenhuma pergunta encontrada",
    confirmDelete: "Tem certeza de que deseja excluir esta pergunta?",
  },

  answer: {
    assistantResponse: "Resposta do assistente",
    attachedImageOptional: "Imagem anexada (opcional)",
    uploadImage: "Enviar imagem",
    clickToSelect: "Clique para selecionar uma imagem",
    changeImage: "Alterar imagem",
    imagePreviewAlt: "Prévia da imagem",
    defaultImageName: "image.jpg",
  },

  phone: {
    online: "online",
    today: "Hoje",
    exampleQuestion: "Pergunta de exemplo",
    writeAnswerPlaceholder: "Escreva uma resposta para esta pergunta...",
    writeMessagePlaceholder: "Digite uma mensagem...",
    answerImageAlt: "Imagem da resposta",
    confirmDeleteImage: "Excluir imagem?",
    imageDeletedSuccess: "Imagem excluída com sucesso.",
    virtualAssistant: "Assistente Virtual",
  },

  search: {
    placeholder: "Buscar por nome, telefone ou código de reserva...",
    noResultsTitle: "Nenhuma conversa encontrada",
    noResultsDescription:
      "Tente outro nome, número de telefone ou código de reserva.",
  },

  archive: {
    title: "Arquivar conversa",
    message:
      "Se você arquivar esta conversa, ela desaparecerá desta lista. Você ainda poderá acessá-la pela reserva vinculada.",
    cancel: "Cancelar",
    confirm: "Arquivar",
  },
};

export default bot;